import * as React from "react";
import { CandyTooltip as BaseTooltip, PopupPositionsType, TooltipTrigger } from "react-ui";

import { LinkParserWrapper, markdownWrapper } from "../../Helpers/LinkWrapper/LinkParserWrapper";
import { CurrencyHelper } from "../ControlsReexport/CustomControls/CurrencyInput/CurrencyHelper";

import { Formula, TooltipContent } from "./Tooltip.styles";

interface TooltipProps {
    formula?: React.ReactNode;
    value?: React.ReactNode | string;
    currencyFractionDigits?: number;
    autoValue?: string;
    width?: number | string;
    children?: React.ReactNode;
    pos?: PopupPositionsType;
    trigger?: TooltipTrigger;
    useWrapper?: boolean;
    combineMessages?: boolean;
    currency?: boolean;
    closeButton?: boolean;
    highlightingTooltipText?: string;
    onCloseClick?: () => void;
}

export function Tooltip(props: TooltipProps): JSX.Element {
    // Чтобы показывать сообщение во время скрытия
    const [lastNonEmptyValue, setLastNonEmptyValue] = React.useState(props.value ?? "");

    React.useEffect(() => {
        if (props.value) {
            setLastNonEmptyValue(props.value);
        }
        if (props.highlightingTooltipText) {
            setLastNonEmptyValue(props.highlightingTooltipText);
        }
    }, [props.value, props.highlightingTooltipText]);

    const renderFormula = () =>
        !props.value && props.formula != undefined && props.formula !== "" ? (
            <>
                <div>Формула для расчета:</div>
                <Formula>{LinkParserWrapper(props.formula)}</Formula>
            </>
        ) : undefined;

    const renderHighlightingText = React.useCallback(
        () => (props.highlightingTooltipText ? markdownWrapper(props.highlightingTooltipText) : undefined),
        [props.highlightingTooltipText]
    );

    const renderTooltipContent = React.useCallback(() => {
        if (props.combineMessages) {
            const formattedAuto = props.currency
                ? CurrencyHelper.format(props.autoValue, {
                      fractionDigits: props.currencyFractionDigits,
                      hideTrailingZeros: false,
                  })
                : props.autoValue;
            return (
                <TooltipContent maxWidth={360}>
                    <div>Значение не равно &apos;{formattedAuto}&apos;</div>
                    {props.formula && (
                        <>
                            <div style={{ marginTop: 4 }}>Формула для расчета</div>
                            <Formula>{LinkParserWrapper(props.formula)}</Formula>
                        </>
                    )}
                </TooltipContent>
            );
        }
        return (
            <TooltipContent maxWidth={props.width}>
                {renderHighlightingText() ?? renderFormula() ?? LinkParserWrapper(lastNonEmptyValue)}
            </TooltipContent>
        );
    }, [props.value, lastNonEmptyValue, props.formula, props.autoValue, renderHighlightingText]);

    return (
        <BaseTooltip
            useWrapper={props.useWrapper}
            width={props.width}
            closeButton={props.closeButton ?? false}
            pos={props.pos}
            trigger={props.formula || props.value || props.highlightingTooltipText ? props.trigger : "closed"}
            hideForTests
            render={renderTooltipContent}
            onCloseClick={props.onCloseClick}>
            {props.children}
        </BaseTooltip>
    );
}
